<template>
  <div id="app">
    <transition-group name="slide-fade">
      <template v-if="getAgeGateToken || $router.currentRoute.params.id === 'tycos' || $router.currentRoute.params.id === 'politics' || $router.currentRoute.params.id === 'cookies'">
        <router-view v-if="$router.currentRoute.params.id === 'tycos'" name="tycos" key="tycos"></router-view>
        <router-view v-else-if="$router.currentRoute.params.id === 'politics'" name="politics" key="politics"></router-view>
        <router-view v-else-if="$router.currentRoute.params.id === 'cookies'" name="cookies" key="cookies"></router-view>
        <router-view v-else key="millerhighlife"></router-view>
        <!-- <BannerCookies /> -->
      </template>
    </transition-group>
    <transition-group name="slide-fade">
      <template v-if="!getAgeGateToken && $router.currentRoute.params.id !== 'tycos' && $router.currentRoute.params.id !== 'politics' && $router.currentRoute.params.id !== 'cookies'">
        <AgeGate key="agegate" />
        <router-view v-if="$router.currentRoute.params.id === 'tycos'" name="tycos" key="tycos"></router-view>
        <router-view v-if="$router.currentRoute.params.id === 'politics'" name="politics" key="politics"></router-view>
        <router-view v-if="$router.currentRoute.params.id === 'cookies'" name="cookies" key="cookies"></router-view>
        <!-- <BannerCookies /> -->
      </template>
    </transition-group>

  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";

import AgeGate from '@/containers/AgeGate'
import BannerCookies from '@/components/BannerCookies'
export default {
  name: "app",
  components: {
    AgeGate,
    BannerCookies
  },
  data() {
    return {
      toggler: false  
    };
  },
  computed: {
    ...mapGetters([
      'getAgeGateToken'
    ])
  },
  methods: {
    ...mapActions({
      setScrollMotionAction: 'setScrollMotion',
      setEdgeScrollingAction: 'setEdgeScrolling',
      resetEdgeScrollingAction: 'resetEdgeScrolling',
      setAgeGateTokenAction: "setAgeGateToken",
    }),
    onScroll ({ target: { scrollTop, clientHeight, scrollHeight }}) {
      if (scrollTop + clientHeight >= (scrollHeight - 5)) {
        this.setScrollMotionAction('downEnd');
      } else if (scrollTop + clientHeight <= (clientHeight + 5)) {
        this.setScrollMotionAction('upStart');
      } else {
        this.setScrollMotionAction('scrolling');
      }
    },
    localStorageInclude(value) {
      let include  = false;
      for (let i = 0; i < localStorage.length; i++) {
        let key = localStorage.key(i);
        let _value = localStorage.getItem(key);
        if(_value === value){
          include = true
        }
      }
      return include
    },
    //OneTrust Cookies Consent Notice start for millerhighlife.com.mx
    loadScripts() {
      const script1 = document.createElement('script');
      script1.src = "https://cdn.cookielaw.org/consent/01930713-b3ec-7618-9df0-5c748eb6a21f/OtAutoBlock.js";
      document.head.appendChild(script1);
      const script2 = document.createElement('script');
      script2.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
      script2.setAttribute('data-document-language', 'true');
      script2.setAttribute('type', 'text/javascript');
      script2.setAttribute('charset', 'UTF-8');
      script2.setAttribute('data-domain-script', '01930713-b3ec-7618-9df0-5c748eb6a21f');
      document.head.appendChild(script2);
      const script3 = document.createElement('script');
      script3.textContent = "function OptanonWrapper() { }";
      document.head.appendChild(script3);
    }
    //OneTrust Cookies Consent Notice end for millerhighlife.com.mx
  },
  mounted() {
    const cookies = document.cookie;
    const OneTrustStorage = this.localStorageInclude('fc482041bb2d2f4b43ee11e07982dabd0c7de2aae21d3df7a093009908878b32');
    const OneTrustCookie = cookies.includes('fc482041bb2d2f4b43ee11e07982dabd0c7de2aae21d3df7a093009908878b32');
    if (OneTrustCookie || OneTrustStorage) {
      this.setAgeGateTokenAction(true);
    }
    this.$nextTick(() => {
    });
    this.loadScripts();
  }
};
</script>

<style lang="scss">
@import "./styles/main.scss";
</style>
